// extracted by mini-css-extract-plugin
export var headerCell = "_1i-1";
export var loadingSpinnerContainer = "_1i-4";
export var rowWrapper = "_1i-3";
export var standaloneTable = "_1i-5";
export var table = "_1i-0";
export var white = "_1i-2";